export const COMMON_SET_FILTER = 'COMMON_SET_FILTER';



// WEBPACK FOOTER //
// ./src/features/common/redux/constants.js